import Card from "components/card";
import { formatPrice } from "utils/price";
import { SOURCE_TYPES } from "utils/constants";
import EllipseIcon from "components/icons/EllipseIcon";
import CicleCheckIcon from "components/icons/CicleCheckIcon";
import EllipseActiveIcon from "components/icons/EllipseActiveIcon";

const StepsCard = ({ state, stepsConfig }) => {
    const source = state?.data?.source;

    return (
        <Card extra={"w-full overflow-x-auto sticky top-0"}>
            <div className="px-4 py-2 md:px-6 md:py-4">
                <div className="relative mb-8 flex items-center">
                    <div className="w-full text-2xl font-bold text-gray-800 dark:text-white">
                        Riepilogo
                    </div>
                </div>

                <div className="flex flex-col gap-6">
                    {stepsConfig?.map(({ number, summaryTitle }) => (
                        <div key={number} className="flex w-full flex-wrap">
                            {/* step number */}
                            <div
                                className={`relative shrink-0 self-center ${
                                    state.step > number
                                        ? "text-blue-600"
                                        : "text-gray-600"
                                }`}
                            >
                                <EllipseIcon />

                                <span className="absolute inset-0 mt-[1px] text-center text-gray-800">
                                    {number}
                                </span>

                                {state.step === number ? (
                                    <div className="absolute top-0 right-0 text-blue-600">
                                        <EllipseActiveIcon />
                                    </div>
                                ) : null}
                            </div>

                            {/* step name */}
                            <p className="mx-2 flex-1 self-center text-sm text-gray-700 dark:text-white">
                                {summaryTitle}
                            </p>

                            {/* check icon */}
                            <div
                                className={`mx-2 shrink-0 self-center ${
                                    state.step === number
                                        ? "text-blue-600"
                                        : "text-gray-600"
                                }`}
                            >
                                {state.step >= number ? (
                                    <CicleCheckIcon />
                                ) : null}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {source !== SOURCE_TYPES.RESELLER && (
                <div className="flex flex-wrap justify-between bg-gray-200 py-6 px-4 md:px-6">
                    <div className="w-full md:w-1/2">
                        <span className="text-base font-bold text-gray-800">
                            Totale provvisorio
                        </span>
                    </div>

                    <div className="flex w-full justify-end md:w-1/2">
                        <span className="text-right text-base font-bold text-gray-800">
                            €{" "}
                            {state.data.total
                                ? formatPrice(state.data.total)
                                : formatPrice(0)}
                        </span>
                    </div>
                </div>
            )}
        </Card>
    );
};

export default StepsCard;
